<template>
  <v-container fluid class="pt-0">
    <v-row dense>
      <v-col cols="12" offset-lg="2" lg="8">
        <master-categories></master-categories>
      </v-col>

    </v-row>
  </v-container>
</template>

<script setup>
import MasterCategories from '@/components/Master/MasterCategories.vue'
</script>
<style scoped>
</style>
